import { AddClinicProviderList, AddClinicProviderListAction, CLINIC_PROVIDER_LIST } from "./types";


export const addClinicProviderList = (clinicProviderList: AddClinicProviderList): AddClinicProviderListAction => {
    return {
        type: CLINIC_PROVIDER_LIST.ADD_CLINIC_PROVIDER,
        payload: clinicProviderList
    };
}